module.exports = __webpack_public_path__ + "static/media/dragonball.65110d91.JPG";